import { ProductTypeEnum } from '../enums/product-capture.enums';
import { DropDownOption } from '../interfaces/drop-down-option.interface';

export const UPSIDE_TYPE_ITEMS = [
  { id: 'NONE', displayValue: 'None' },
  { id: 'CALL', displayValue: 'Call' },
  { id: 'KNOCK_OUT_CALL', displayValue: 'Knock Out Call' },
  { id: 'TWIN_WIN', displayValue: 'Twin Win' },
  { id: 'KNOCK_OUT_TWIN_WIN', displayValue: 'Knock Out Twin Win' },
  { id: 'DIGITAL', displayValue: 'Digital' },
  // TODO: Waiting for more details from Stuart/James/Ben
  // { id: 'PUT', displayValue: 'Put' },
];

export const filterUpsideOptions = (options: any[]): DropDownOption[] =>
  UPSIDE_TYPE_ITEMS.filter((opts: DropDownOption) => options.includes(opts.id));

const PARTICIPATION_SUPERTRACKER_OPTIONS = filterUpsideOptions([
  'CALL',
  'KNOCK_OUT_CALL',
  'DIGITAL',
]);

export const PRODUCT_UPSIDE_TYPES = new Map<ProductTypeEnum, DropDownOption[]>([
  [
    ProductTypeEnum.AUTOCALL_GROWTH_AT_MATURITY,
    filterUpsideOptions(['CALL', 'KNOCK_OUT_CALL', 'PUT']),
  ],
  [ProductTypeEnum.PARTICIPATION_NOTE, PARTICIPATION_SUPERTRACKER_OPTIONS],
  [ProductTypeEnum.SUPERTRACKER, PARTICIPATION_SUPERTRACKER_OPTIONS],
  [
    ProductTypeEnum.PERFORMANCE_LINKED_COUPON,
    PARTICIPATION_SUPERTRACKER_OPTIONS,
  ],
]);
